import { Component, OnInit } from '@angular/core';

import { id } from '@swimlane/ngx-charts';
import moment from 'moment';
import { finalize, tap, observable, catchError, throwError } from 'rxjs';
import { User } from 'src/models/user';
import { APICustomdashboardService } from 'src/services/api-services/api-custom-dashboard';
import { APICustomScheduleService } from 'src/services/api-services/api-custom-schedule-service';
import { CustomSchedule } from 'src/services/api-services/api-interfaces/custom-schedule.interface';
import { APISchedulerService } from 'src/services/api-services/api-scheduler-service';
import { APIUserDealerService } from 'src/services/api-services/api-user-dealer';
import { APIWorkshopService } from 'src/services/api-services/api-workshop.service';
import { HelperService } from 'src/services/helperService';
import { MetricCard } from './metric-card';
import { advisor } from '../../models/advisor';
import { Observable } from 'rxjs/internal/Observable';
import { Appointment } from '../../models/appointment';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.sass'],
    standalone: false
})
export class DashboardComponent implements OnInit {
  calendarGrid: string = 'col-lg-6'
  chartGrid: string = 'col-lg-6'
  chartGrid2: string = 'col-lg-12'
  isChartExpanded: boolean = false

  isLoading: boolean = true;
  userProfile?: User;
  metricCards: MetricCard[] = [];

  constructor(
    public dashboardService: APICustomdashboardService,
    public helperService: HelperService,
    public WorkshopService: APIWorkshopService, 
    public schedulerService: APISchedulerService,
    public customScheduleService: APICustomScheduleService,
    public UserDealerservice :APIUserDealerService,
    private router: Router,public appComponent:AppComponent
    ) 
    {
    
    this.helperService.icon = 'insert_chart';
      if (this.helperService.user.role.roleId === 7) {
        this.router.navigate(['administration/users']);
      }
     }

  dataKPI: Observable<any> = new Observable<any>()

   ngOnInit(): void {
    this.userProfile = this.helperService.user;
    // this.metricCards = this.evaluateUserDisplayedMetricCards()
    this.getUserDealer()  
 }
 
  selectedMonth: number = 0;

  years: string[] = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  
  item: any

  Asistencia: string = 'Asistencia'
  Inasistencia: string = 'Inasistencia'
  Citascanceladas: string = 'Citas canceladas'
  CitasAgendadas: string = 'Citas agendadas'
  AsistenciaAdvisor: string = 'Asistencia'
  InasistenciaAdvisor: string = 'Inasistencia'
  ContactCenter: string = 'Participación Contact Center'
  AtencionesSinCita: string = 'Atenciones sin cita'

  superAdminMetricCards: MetricCard[] = [];
  workshopManagerMetricCards: MetricCard[] = [];
  serviceAdvisorMetricCards: MetricCard[] = [];
  contactCenterAdvisorMetricCards: MetricCard[] = [];
  brandingConsultantMetricCards: MetricCard[] = []
  workshopAssistantMetricCards: MetricCard[] = []
  
  expandCollapseChart(toExpand: boolean): void {

    let currentDate = moment();
    this.isChartExpanded = toExpand;
    this.calendarGrid = toExpand ? 'col-lg-1' : 'col-lg-6';
    this.chartGrid = toExpand ? 'col-lg-11' : 'col-lg-6';
    this.chartGrid2 = toExpand ? 'col-lg-12': 'col-lg-12';

    this.selectedMonth = currentDate.month() + 1;
    
    window.setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
    }, 300);
    
  }

  datenoshowContactd:any []=[]
  workshopsData: any[] = [];
  UserDealersData: any[] = [];
  customdash:any=[]
  
  getUserDealer(){
    this.metricCards = this.evaluateUserDisplayedMetricCards()
  }

  getDataKPIs(roleId:number, countryId:any, startDate:any, endDate:any, mode:any, specificId?:any)
  {
   this.dataKPI = this.dashboardService?.getKPIs(roleId, countryId, startDate, endDate, specificId).pipe(
     tap((response) => {
      this.isLoading = false;
     }), catchError((error: any) => {
               // Handle validation error here
               if(error.status === 401){
                this.helperService.logoutToken()
              }
             console.error('Validation Error:', error);
             // Rethrow the error to propagate it downstream
             return throwError(error);
             })
   )
  }

getLastDayOfMonth(year, month): number {
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  firstDay.setHours(0, 0, 0, 0);
  lastDay.setHours(0, 0, 0, 0);

  const diff = (lastDay.getTime() - firstDay.getTime()) / 86400000 + 1;

  return Math.round(diff);
}
    
  evaluateUserDisplayedMetricCards(): MetricCard[] {

    switch (this.helperService.user.role.roleId) {
      
      case 1: //Service Advisor Profile

        this.monday.setDate(this.monday.getDate() - (6 - (6- this.monday.getDay() + 
        1)) ); 
        this.saturday.setDate(this.saturday.getDate() + (6 -this.saturday.getDay())); 
        this.getDataKPIs(this.helperService.user.role.roleId,this.helperService.user.countryId, moment(this.monday).format("YYYY-MM-DD"),moment(this.saturday).format("YYYY-MM-DD"),1,this.helperService.user.advisorId)

      return this.serviceAdvisorMetricCards;

      case 2: //Workshop Super Admin

        this.getDataKPIs(this.helperService.user.role.roleId, this.helperService.user.countryId, this.Datereal.getFullYear()+"-"+
        (this.Datereal.getMonth()+1)+"-"+ 1,this.Datereal.getFullYear()+"-"+ 
        (this.Datereal.getMonth()+1)+"-"+
        this.getLastDayOfMonth(this.Datereal.getFullYear(), this.Datereal.getMonth() ), 1, this.helperService.user.workshopId)

      return this.workshopManagerMetricCards;

      case 3: //Contact Center Advisor
        this.getDataKPIs(this.helperService.user.role.roleId, this.helperService.user.countryId, moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD"), 3)
    
      return this.contactCenterAdvisorMetricCards;

      case 4: //Super Retail Group Administrator

        this.getDataKPIs(this.helperService.user.role.roleId, this.helperService.user.countryId, this.Datereal.getFullYear()+"-"+
        (this.Datereal.getMonth()+1)+"-"+ 1,this.Datereal.getFullYear()+"-"+ (this.Datereal.getMonth()+1)+"-"+ 
        this.getLastDayOfMonth(this.Datereal.getFullYear(), this.Datereal.getMonth() ),1,this.helperService.user.retailId)

      return this.superAdminMetricCards;

      case 5: //Branding Consultant

        this.getDataKPIs(this.helperService.user.role.roleId, this.helperService.user.countryId, this.Datereal.getFullYear()+"-"+
        (this.Datereal.getMonth()+1)+"-"+ 1,this.Datereal.getFullYear()+"-"+ (this.Datereal.getMonth()+1)+"-"+ 
        this.getLastDayOfMonth(this.Datereal.getFullYear(), this.Datereal.getMonth() ), 1, this.helperService.user.userid)

      return this.brandingConsultantMetricCards;

      case 6: //Workshop Assistant

      this.getDataKPIs(this.helperService.user.role.roleId, this.helperService.user.countryId, moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD"), 6, this.helperService.user.workshopId)

      return this.workshopAssistantMetricCards;

      default:
        
        return this.contactCenterAdvisorMetricCards;
    }
  }
  
  daysInMonth(month:number, year:number) {
    return new Date(year, month, 0).getDate();
  }

  Datereal = new Date();
  monday = new Date ();
  saturday = new Date ();

}
